import { render, staticRenderFns } from "./activate-stamp.vue?vue&type=template&id=41b9c266&"
import script from "./activate-stamp.vue?vue&type=script&lang=ts&"
export * from "./activate-stamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports